import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import { getStyleJSON, getData } from "Utils/Common";
import AngCheckbox from "Common/Angular/AngCheckbox";
import errordialog from "Common/errordialog";
import store from "store";

const taskname = "downloadlbsevents";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    this.state = {
      taskConfig: {
        accountdetail: accountdetailrow,
        downloadevents: null,
      },
    };
  }

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  componentDidMount = () => {
    this.loadData();
  };

  loadData = () => {
    const { accountdetailrow } = this.props;
    var dataparams = {
      accountdetail: accountdetailrow,
      datakey: taskname,
    };
    store.dispatch({ type: "ISLOADING", payload: true });
    getData(dataparams, (response) => {
      const {
        data: {
          ok,
          data: { downloadlbsevents },
        },
      } = response;
      if (ok) {
        this.setState((s, p) => ({
          taskConfig: {
            ...s.taskConfig,
            downloadevents: downloadlbsevents,
          },
        }));
        if (!downloadlbsevents) {
          errordialog.showError(
            "No Leaderboard data detected. Please contact administrator."
          );
        }
      }
      store.dispatch({ type: "ISLOADING", payload: false });
    }).catch((error) => {
      store.dispatch({ type: "ISLOADING", payload: false });
      error.response &&
        error.response.data &&
        errordialog.showError(error.response.data.message);
    });
  };

  validate = () => {
    const { state } = this;
    const {
      taskConfig: { downloadevents },
    } = state;
    let isAtleastOneSelected = false;
    downloadevents.forEach((event) => {
      if (event.isselected === true) {
        isAtleastOneSelected = true;
      }
    });
    if (!isAtleastOneSelected) {
      alert("Please select atleast one Event to download.");
      return false;
    }
    return true;
  };

  render = () => {
    const { validate, state } = this;
    const {
      taskConfig,
      taskConfig: { downloadevents },
    } = state;

    if (!downloadevents) {
      return null;
    }

    return (
      <TaskDialog heading={"Leaderboard Pull"}>
        <div
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; width: 300px;padding-bottom:10px;"
          )}
        >
          Select Events to extract
        </div>
        {downloadevents.map((event) => {
          return (
            <div
              style={getStyleJSON(
                "border: solid 1px;display:flex;padding:5px;"
              )}
            >
              <div
                style={getStyleJSON(
                  `padding-left: 20px;
                   padding-right: 0px;
                   width: 30px;
                   margin-top: auto;
                   margin-bottom: auto;`
                )}
              >
                <AngCheckbox
                  value={event.isselected}
                  onChange={() => {
                    event.isselected = !event.isselected;
                    this.forceUpdate();
                  }}
                />
              </div>
              <div style={{ flex: "1" }}>
                <EventDetails event={event} />
              </div>
            </div>
          );
        })}

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run LB Pull"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}

const EventDetails = ({ event }) => {
  return (
    <>
      <div style={getStyleJSON("text-align: center;")}>{event.eventname}</div>
      <div style={getStyleJSON("text-align: center;")}>({event.eventid})</div>
      <div style={getStyleJSON("text-align: center; font-size: 10px;")}>
        Event Endtime
      </div>
      <div style={getStyleJSON("text-align: center; font-size: 10px;")}>
        {event.eventendduration}
      </div>
      <div style={getStyleJSON("text-align: center; font-size: 10px;")}>
        Reward Claim Endtime
      </div>
      <div style={getStyleJSON("text-align: center; font-size: 10px;")}>
        {event.rewardendduration}
      </div>
    </>
  );
};
